import { QFilterGeneric } from './QFilterGeneric'

export class QFilterUnitsPage extends QFilterGeneric {
  name = "units_per_page";
  class_name = "QFilterUnitsPage";
  api_name = 'items_per_page';
  
}
